// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"370":"fd3b26b8","453":"ba2930c9"}[chunkId] + ".chunk.js";
};